var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84693 14.8355C11.884 14.8355 15.1567 11.5627 15.1567 7.52564C15.1567 3.48854 11.884 0.21582 7.84693 0.21582C3.80983 0.21582 0.537109 3.48854 0.537109 7.52564C0.537109 11.5627 3.80983 14.8355 7.84693 14.8355ZM11.2342 6.34429C11.591 5.98745 11.591 5.40891 11.2342 5.05208C10.8774 4.69525 10.2988 4.69525 9.942 5.05208L6.9332 8.06088L5.75185 6.87953C5.39501 6.5227 4.81647 6.5227 4.45964 6.87953C4.10281 7.23637 4.10281 7.81491 4.45964 8.17174L6.2871 9.99919C6.64393 10.356 7.22247 10.356 7.5793 9.99919L11.2342 6.34429Z",
    fill: "#22C55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferIcon);
export default __webpack_public_path__ + "static/media/offerIcon.688bd0f13d27bd49dff28409251cde45.svg";
export { ForwardRef as ReactComponent };